import {encodeBase64Url} from './encodeBase64Url';

const PKCE_DIGEST_ALGORITHM = 'SHA-256';

export const generatePkceChallenge = async (verifier: string) => {
  const digest = await crypto.subtle.digest(
    PKCE_DIGEST_ALGORITHM,
    new TextEncoder().encode(verifier)
  );
  return encodeBase64Url(new Uint8Array(digest));
};
